export var IS_PRODUCTION = process.env.NODE_ENV === 'production';
//# sourceMappingURL=environment.js.map


//////////////////
// WEBPACK FOOTER
// ./~/xstate/es/environment.js
// module id = 13
// module chunks = 0